import React from 'react';
import { Field, reduxForm } from 'redux-form';
import validate from '../common/validate';

const lower = value => value && value.toLowerCase();

const renderField = ({ input, label, type, description, meta: { touched, error } }) => (
  <div className="form-group">
    <input
      className="form-control"
      {...input}
      placeholder={label}
      type={type}/>
    <span className="input-description">{description}</span>
    <div>
      {touched && (error && <span className="text-danger absolute login-form-error">{error}</span>)}
    </div>
  </div>
)

class LoginForm extends React.Component {
  render() {
    const { handleSubmit, inProgress } = this.props;
    return (
      <form onSubmit={handleSubmit} id="loginForm">
        <div className="login-form-input">
          <Field
            name="email"
            component={renderField}
            type="text"
            label="Email"
            description="Please enter the email address where you received an invitation."
            normalize={lower}/>
        </div>
        <div className="login-form-input">
          <Field
            name="loginPassword"
            component={renderField}
            type="password"
            label="Password"
            validate={() => undefined}
            description="Please enter the password you received in your invitation email if you haven't changed it."/>
        </div>
        <button
          className="col-md-8 btn btn-block btn-primary pull-right mt-3"
          disabled={inProgress}
          type="submit">Submit</button>
      </form>
    );
  }
}

export default LoginForm = reduxForm({
  form: 'login',
  validate
})(LoginForm);



// WEBPACK FOOTER //
// ./src/components/login/LoginForm.js